export default "__VITE_ASSET__CVKrjqjM__"